import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { Observable } from 'rxjs';
import { dateToNgb, ngbToString } from '../../services/datetime.service';
import { CurrentDate, UpdateSelectedDate, UpdateShowToggle } from './date.action';
import { DateState } from './date.state';

@Injectable({ providedIn: 'root' })
export class DateFacade {
  @Select(DateState.getCurrentDate) currentDate$: Observable<any>;
  @Select(DateState.UpdateSelectedDate) selectedDate$: Observable<any>;
  constructor(private store: Store, private parameterService: ParameterHandlerService) {}

  public CurrentDate(value: any): void {
    this.parameterService.setParameter('date', dateToNgb(value));
    this.store.dispatch(new CurrentDate(value));
  }

  public UpdateSelectedDate(value?: any): void {
    let selectedDate = `${value.day < 10 ? `0${value.day}` : value.day}/`;
    selectedDate += `${value.month < 10 ? `0${value.month}` : value.month}/${value.year}`;
    this.store.dispatch(new UpdateSelectedDate(selectedDate));
    this.parameterService.setParameter('date', ngbToString(value));
  }

  public UpdateItemParameterService(): string {
    return this.parameterService.parameters.item('date').value;
  }

  public UpdateToggleCalendar(): void {
    this.store.dispatch(new UpdateShowToggle(true));
  }
}
